// FactStrip - the five-second answer. Live facts link to the page they
// were counted from; stored facts show their source and review state.
import React from "react";
import { sourceText } from "./glanceModel";

export default function FactStrip({ facts, onOpen }) {
  if (!facts || !facts.length) return null;
  return (
    <div className="g-strip">
      {facts.map((f) => {
        const pending = f.by === "claude" && f.review === "pending";
        const title = [f.detail, sourceText(f.source) && `Source: ${sourceText(f.source)}`, f.reviewedBy && `Reviewed by ${f.reviewedBy}`].filter(Boolean).join("\n");
        const body = (
          <>
            <b>{f.label}{pending && <span className="g-badge" title="Proposed automatically from the source documents; not yet reviewed">Pending</span>}</b>
            <span>{f.detail}</span>
          </>
        );
        return f.link && onOpen
          ? <button key={f.key} type="button" title={title} onClick={() => onOpen(f.link)}>{body}</button>
          : <div key={f.key} title={title}>{body}</div>;
      })}
    </div>
  );
}
